<div class="notif-panel-wrap" (click)="$event.stopPropagation()">

  <!-- Header -->
  <div class="notif-panel-header">
    <div class="notif-panel-title">
      List Of Notifications ( Total - 
      <span *ngIf="notifService.totalCount > 0">
        {{ notifService.totalCount }} )
      </span>
    </div>
    <div class="notif-panel-actions">
      <button class="notif-action-btn"
              [class.enabled]="selectedIds.size > 0"
              [disabled]="selectedIds.size === 0"
              (click)="markSelectedAsRead()"
              title="Mark selected as read">
        <i class="bi bi-check2"></i>
      </button>
      <button class="notif-action-btn notif-delete-btn"
              [class.enabled]="selectedIds.size > 0"
              [disabled]="selectedIds.size === 0"
              (click)="deleteSelected()"
              title="Delete selected">
        <i class="bi bi-trash3"></i>
      </button>
    </div>
  </div>

  <!-- Body -->
  <div class="notif-panel-body">
    <ng-container *ngIf="notifService.groupedNotifications.length > 0; else emptyTpl">

      <div *ngFor="let group of notifService.groupedNotifications" class="notif-group">

        <!-- Group label -->
        <div class="notif-group-label">
          {{ group.label }} ({{ group.items.length }})
        </div>

        <!-- Notifications card -->
        <div class="notif-card">
          <div *ngFor="let notif of group.items; let last = last"
               class="notif-item"
               [class.notif-item--last]="last"
               [class.notif-item--unread]="!notif.isRead"
               [class.notif-item--clickable]="notif.navigation"
               (click)="notif.navigation && navigateToNotification(notif)">

            <label class="notif-checkbox" (click)="$event.stopPropagation()">
              <input type="checkbox"
                     [checked]="selectedIds.has(notif.id)"
                     (click)="$event.stopPropagation(); toggleSelect(notif.id)" />
            </label>

            <div class="notif-avatar"
                 [style.background]="notifService.getAvatarColor(notif.senderInitial)">
              {{ notif.senderInitial }}
            </div>

            <!-- FIX 2: Message + date/time block stacked -->
            <div class="notif-content">
              <div class="notif-message">{{ notif.message }}</div>
              <div class="notif-timestamp">
                <span class="notif-date">{{ notif.displayDate }}</span>
                <span class="notif-time-sep">·</span>
                <span class="notif-time">{{ notif.displayTime }}</span>
              </div>
            </div>

            <div class="notif-meta">
              <span class="notif-unread-dot" *ngIf="!notif.isRead"></span>
            </div>

          </div>
        </div>

      </div>
    </ng-container>

    <ng-template #emptyTpl>
      <div class="notif-empty">
        <i class="bi bi-bell-slash"></i>
        <p>No notifications</p>
      </div>
    </ng-template>
  </div>

</div>